import { createFileRoute } from '@tanstack/react-router'

import { StatsByDatePage } from '@/pages/stats-by-date-page'

export const Route = createFileRoute('/_dashboard/_stats-layout/stats/by-date')({
    component: StatsByDatePage,
})
